import React from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";

import { CardLayout } from "../v3";
import { get_date } from "../generalComponets";

export const TenderDetails = ({ projectDetails = {} }) => {
  const agreementPeriod = Number(projectDetails?.tender?.agreementDuration);
  const dlpPeriod = Number(projectDetails?.dlp?.duration);

  const detailRows = [
    {
      leftLabel: "Agreement Date",
      leftValue: get_date(projectDetails?.tender?.agreementDate),
      rightLabel: "Agreement Period",
      rightValue:
        agreementPeriod === 0 || agreementPeriod === 1
          ? `${agreementPeriod} month`
          : agreementPeriod > 1
            ? `${agreementPeriod} months`
            : "Not Provided",
    },
    {
      leftLabel: "Site Handover Date",
      leftValue: get_date(projectDetails?.tender?.siteHandoverDate),
      rightLabel: "Completion Date",
      rightValue: get_date(projectDetails?.tender?.agreementEndDate),
    },
    {
      leftLabel: "DLP Period",
      leftValue:
        dlpPeriod === 0 || dlpPeriod === 1 ? `${dlpPeriod} month` : dlpPeriod > 1 ? `${dlpPeriod} months` : "Not Provided",
      rightLabel: "DLP Notes",
      rightValue: projectDetails?.dlp?.notes || "Not Provided",
    },
  ];
  return (
    <CardLayout sx={{ margin: "11px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#674BF5" }}>
          Tender Info
        </Typography>
      </Box>

      <Stack spacing={2}>
        {/* details reusable row */}
        {detailRows.map((row, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            <Box sx={{ flex: "1 1 45%" }}>
              <Typography variant="caption">{row.leftLabel}</Typography>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {row.leftValue}
              </Typography>
            </Box>

            <Divider orientation="vertical" flexItem sx={{ height: 35, alignSelf: "center" }} />

            <Box sx={{ flex: "1 1 45%" }}>
              <Typography variant="caption">{row.rightLabel}</Typography>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {row.rightValue}
              </Typography>
            </Box>
          </Box>
        ))}
      </Stack>
    </CardLayout>
  );
};
